module.exports = __webpack_public_path__ + "static/media/wheat-about-google.51277c94.png";